import { PermissionKey, usePermissions } from "features/users";
import get from "lodash/get";
import { ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { ROUTES } from "./constants";

type RestrictedRouteProps = {
  children: ReactElement;
  requiredPermission: PermissionKey;
  redirectPath: string;
};

export const RestrictedRoute = ({
  children,
  requiredPermission,
}: RestrictedRouteProps) => {
  const permissions = usePermissions();

  if (!permissions) return null;

  const isAllowed = get(permissions, requiredPermission);

  if (isAllowed) {
    return children;
  }

  if (permissions.booking?.view) {
    return <Navigate to={ROUTES.BOOKINGS} replace />;
  }

  if (permissions.facilities?.view) {
    return <Navigate to={ROUTES.FACILITIES} replace />;
  }

  return <Navigate to={ROUTES.LOGIN} replace />;
};
